import React from 'react';
import { TextEditor } from '../../../../../../components/TextEditor';
import { TextAreaEdit } from '../../../../components/TextAreaEdit';
import { TextElementSelectWrapper } from '../../../../components/TextElementSelectWrapper';
import { ElementHeaderType } from '../../../utils';
import {
  HomeImageTwoLeftDescriptionFloatingWindowElement,
  IconHeadingAndDescription,
} from './HomeImageTwoLeftDescriptionFloatingWindowElement';
import { HomeImageTwoLeftDescriptionFloatingWindowIcon } from './HomeImageTwoLeftDescriptionFloatingWindowIcon';

interface Props {
  data: HomeImageTwoLeftDescriptionFloatingWindowElement;
  update: (
    fieldsToUpdate: Partial<HomeImageTwoLeftDescriptionFloatingWindowElement>
  ) => void;
}

export const HomeImageTwoLeftDescriptionFloatingWindowContent: React.FC<
  Props
> = ({ data, update }) => {
  const updateData = (to: Partial<IconHeadingAndDescription>, idx: number) => {
    const icons_titles = [...data.icons_headings];
    icons_titles[idx] = { ...icons_titles[idx], ...to };
    update({ ...data, icons_headings: icons_titles });
  };
  return (
    <div className="showcase__content">
      {data.icons_headings.map((item, idx) => (
        <div className="u-contain">
          <HomeImageTwoLeftDescriptionFloatingWindowIcon
            idx={idx}
            data={item}
            update={updateData}
          />
          {/*begin::Heading*/}
          <TextElementSelectWrapper
            name={`heading_type`}
            value={item.heading_type ?? ElementHeaderType.H2}
            setValue={(value) =>
              updateData({ heading_type: value as ElementHeaderType }, idx)
            }
          >
            <TextAreaEdit
              name="heading"
              className="heading"
              value={item.heading}
              setValue={(val) => updateData(val, idx)}
            />
          </TextElementSelectWrapper>
          {/*end::Heading*/}

          {/*begin::Description*/}

          <div className="description_input prose">
            <TextEditor
              content={item.description}
              updateContent={(description) => updateData({ description }, idx)}
            />
          </div>
          {/*end::Description*/}
        </div>
      ))}
    </div>
  );
};
